<template>
    <div class="page-container">
      <div class="forgot-password-container">
        <h2>Forgot Password</h2>
        <form @submit.prevent="requestPasswordReset">
          <div class="input-group">
            <label for="email">Email:</label>
            <input type="email" v-model="email" required />
          </div>
          <button type="submit" class="submit-button">Send Password Reset Link</button>
        </form>
        <p v-if="message" class="notification" :class="{'error': isError, 'success': isSuccess}">{{ message }}</p>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';

  export default {
    data() {
      return {
        email: '',
        message: '',
        isError: false,
        isSuccess: false,
      };
    },
    methods: {
      async getIpAddress() {
        try {
          const response = await axios.get('https://api.ipify.org?format=json');
          return response.data.ip;
        } catch (error) {
          console.error('Failed to fetch IP address:', error);
          return null;
        }
      },
      async requestPasswordReset() {
        try {
          const ipAddress = await this.getIpAddress();

          // Adjust the request to use the API gateway
          await axios.post('http://api.pacmis/api/auth/forgot-password', {
            email: this.email,
            ip: ipAddress,
          });

          // Show success notification
          this.showNotification('Password reset link has been sent to your email!', false);
        } catch (error) {
          console.error('Error sending password reset link:', error);
          this.showNotification(
            error.response?.data.error || 'Failed to send password reset link',
            true
          );
        }
      },
      showNotification(message, isError = false) {
        this.message = message;
        this.isError = isError;
        this.isSuccess = !isError;

        // Automatically hide the notification after 5 seconds
        setTimeout(() => {
          this.message = '';
          this.isError = false;
          this.isSuccess = false;
        }, 5000); // Notification disappears after 5 seconds
      },
    },
  };
  </script>

  <style scoped>
  .page-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: backgroundAnimation 10s infinite;
  }

  .forgot-password-container {
    max-width: 400px;
    padding: 20px;
    background-color: rgba(37, 3, 59, 0.9);
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(238, 233, 233, 0.1);
    text-align: center;
  }

  h2 {
    font-size: 24px;
    color: #fff;
  }

  .input-group {
    margin-bottom: 15px;
    text-align: left;
  }

  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #ccc;
  }

  input {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
  }

  .submit-button {
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    background-color: #007bff;
    color: #fff;
  }

  .notification {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 10px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 16px;
  }

  .error {
    color: #ffffff;
    background-color: #ff4d4d;
  }

  .success {
    color: #ffffff;
    background-color: #28a745;
  }

  @keyframes backgroundAnimation {
    0% {
      background-color: rgba(102, 223, 245, 0.438);
    }
    50% {
      background-color: rgba(102, 145, 245, 0.438);
    }
    100% {
      background-color: rgba(102, 223, 245, 0.438);
    }
  }
  </style>
